import { createAction } from '@reduxjs/toolkit';
export var initMOP = createAction('Payment/INITIALIZE_MOP');
export var createMOP = createAction('Payment/CREATE_MOP');
export var loadMOP = createAction('Payment/LOAD_MOP');
export var updateMOP = createAction('Payment/UPDATE_MOP');
export var updatePaymentState = createAction('Payment/UPDATE_PAYMENT_STATE');
export var createMOPSuccess = createAction('Payment/CREATE_MOP_SUCCESS');
export var createMOPError = createAction('Payment/CREATE_MOP_ERROR');
export var updateMOPError = createAction('Payment/UPDATE_MOP_ERROR');
export var updateFormFieldData = createAction('Payment/UPDATE_FORM_FIELD_DATA');
export var resetPaymentForm = createAction('Payment/RESET_PAYMENT_FORM');
export var resetRecurlyPaymentForm = createAction('Payment/RESET_RECURLY_PAYMENT_FORM');
export var updateBillingAddress = createAction('Payment/UPDATE_BILLING_ADDRESS');
export var updateDeviceData = createAction('Payment/UPDATE_DEVICE_DATA');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/PaymentState.actions.js
// module id = 56
// module chunks = 11